exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.monthlyfwbStyle p {\n  display: inline;\n}", ""]);

// exports
